module.exports = __webpack_public_path__ + "media/images/smart_phone/products/kome1-d9296e582f757247ef73850956ff50f2.jpeg";